export class DocumentTypesView {
    constructor(
      public documentTypeId: number,
      public type: string,
      public description: string
    ) { }
}